<template>

  <!-- Job -->
  <v-list-item v-if="wrapper.tag === 'Jobs'" link class="pl-3"
    :to="{ name: 'ViewJob', params: { filter: 'my', jobId: item.Id } }">
    <v-list-item-icon class="ma-auto mr-2">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" size="18" v-text="statusicon(item.StatusId)">
          </v-icon>
        </template>
        <span>{{ item.StatusName }}</span>
      </v-tooltip>
    </v-list-item-icon>
    <v-list-item-content class="py-0">
      <v-list-item-title>{{ item.DisplayName }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="ma-auto mx-2 d-flex flex-row rounded-lg" style="background-color: #f7f7f7">
      <template v-for="(node, index) in viewJobNode.children">
        <template v-if="!node.hide && !(index == 0 || index == 2 || index == 5)">
          <v-tooltip bottom :key="node.name">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon small class="rounded-0"
                :to="{ name: node.name, params: { filter: 'my', jobId: item.Id } }">
                <v-icon size="18" v-text="routeIcon(node)" />
              </v-btn>
            </template>
            <span v-text="routeDisplayName(node)" />
          </v-tooltip>
        </template>
      </template>
    </v-list-item-action>
    <v-list-item-action class="ma-auto ml-2 d-flex flex-row">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" small icon color="secondary" class="rounded-0"
            @click.prevent="GetServiceReportLink(item.Id, true)">
            <v-icon size="20">mdi-receipt-text</v-icon>
          </v-btn>
        </template>
        <span v-text="$t('servicesystem.common_objects.commonterms.service_report')" />
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>

  <!-- Machine -->
  <v-list-item v-else-if="wrapper.tag === 'Machines'" link class="px-3"
    :to="{ name: 'ViewMachine', params: { machineId: item.Id } }">
    <v-list-item-icon class="ma-auto mr-2">
      <v-icon size="18" :color="item.IsActive ? '' : 'disabled'">$machine</v-icon>
    </v-list-item-icon>
    <v-list-item-content class="py-0">
      <v-list-item-title :class="item.IsActive ? '' : 'disabled--text'">{{ item.DisplayName }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="ma-auto ml-2 d-flex flex-row">
      <v-tooltip bottom :disabled="!item.IsActive">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on"
            :to="{ name: 'NewJobOverview', query: { customerId: item.CustomerId, machineId: item.Id } }" small icon
            :disabled="!item.IsActive" :color="item.IsActive ? 'quaternary' : 'disabled'">
            <v-icon size="20">mdi-briefcase-plus</v-icon>
          </v-btn>
        </template>
        <span v-text="$t('servicesystem.common_objects.job.new')" />
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>

  <!-- Customer -->
  <v-list-item v-else-if="wrapper.tag === 'Customers'" link class="px-3"
    :to="{ name: 'ViewCustomer', params: { customerId: item.Id } }">
    <v-list-item-icon class="ma-auto mr-2">
      <v-icon size="18" v-text="'$customer'" :color="item.IsActive ? '' : 'disabled'"></v-icon>
    </v-list-item-icon>
    <v-list-item-content class="py-0">
      <v-list-item-title :class="item.IsActive ? '' : 'disabled--text'">{{ item.Id }} {{ item.Name
      }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-icon class="ma-auto mx-2">
      <v-icon size="18" :color="item.IsActive ? 'gray' : 'disabled'">mdi-map-marker</v-icon>
    </v-list-item-icon>
    <v-list-item-content v-if="item.DefaultDeliveryAddress" class="py-0">
      <v-list-item-subtitle :class="item.IsActive ? '' : 'disabled--text'">{{ item.DefaultDeliveryAddress.Street }}
        {{ item.DefaultDeliveryAddress.Zip }} {{ item.DefaultDeliveryAddress.City }}
        {{ item.DefaultDeliveryAddress.Country }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="ma-auto ml-2 d-flex flex-row">
      <v-tooltip bottom :disabled="!item.IsActive">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" :to="{ name: 'NewJobOverview', query: { customerId: item.Id } }" small icon
            :disabled="!item.IsActive" :color="item.IsActive ? 'quaternary' : 'disabled'">
            <v-icon size="20">mdi-briefcase-plus</v-icon>
          </v-btn>
        </template>
        <span v-text="$t('servicesystem.common_objects.job.new')" />
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>

  <v-list-item v-else link dense>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ item[wrapper.itemtextkey] }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import NavMixin from "@/helpers/Mixins/NavMixin.js";
import mtViewJobBranch from "@/router/mt-job-view-branch.js";

export default {
  name: "SearchItemWrapper",
  props: {
    wrapper: Object,
    item: Object,
  },
  components: {},
  mixins: [clientAPI, NavMixin],

  data() {
    return {
      viewJobNode: mtViewJobBranch,
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>

<style scoped lang="scss"></style>